import { useMemo } from 'react';
import {
  taskSupportWallet,
  wsotSupportWallet,
  redemptionSupportWallet,
} from '@/config';
import { useWallet as useWalletBase } from '@web3/base-hooks';
import { WalletType } from '@web3/base-utils';
import { thirdPartyWallet, useCurrentWallet } from '@web3fe/infra';

export const useWallet = () => {
  const walletBase = useWalletBase();

  const supportCommonTask = useMemo(() => {
    return taskSupportWallet.includes(walletBase.walletType);
  }, [walletBase.walletType]);

  const supportWsotTask = useMemo(() => {
    return wsotSupportWallet.includes(walletBase.walletType);
  }, [walletBase.walletType]);

  const twitterConnectCodeKey = useMemo(
    () =>
      walletBase.walletId ? `twitter-connect-code-${walletBase.walletId}` : '',
    [walletBase.walletId]
  );

  return {
    ...walletBase,
    supportCommonTask,
    supportWsotTask,
    twitterConnectCodeKey,
  };
};

export const useRedemptionWallet = () => {
  const wallet = useWalletBase();
  const { isNone } = useCurrentWallet();

  return {
    wallet,
    isConnectedWallet: !isNone,
    // NOTE 条件 1 判断是否是bybit 插件钱包，条件 2 判断是否是bybit云钱包
    isBybitWallet:
      (wallet.isThird && thirdPartyWallet.isBybitWalletExtension) ||
      wallet.isBybitWallet,
    isPrivateKeyWallet: wallet.walletType === WalletType.PRIVATE_KEY,
    supportRedemption: redemptionSupportWallet.includes(wallet.walletType),
  };
};
